export default __webpack_public_path__ + "static/halcyon-bold-cc100846afd164be77c54d1ddb5a97b3.ttf";